export const dashboard = {
  /** Browser tab title (set by the Async component via useAsyncPageDocumentTitle). */
  documentTitle: "Dashboard",
};
